import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../../lib/api";
import { ProductCard } from "../../components/shared/ProductCard";
import { EmptyState } from "../../components/shared/EmptyState";
import { CATEGORIES, mapApiProduct } from "../../data/mockData";

export default function CategoryPage() {
  const { categorySlug } = useParams();
  const isAll = !categorySlug || categorySlug === "tous";
  const category = CATEGORIES.find((c) => c.slug === categorySlug);
  const [apiProducts, setApiProducts] = useState(null);
  const [themes, setThemes] = useState([]);
  const [theme, setTheme] = useState("");
  useEffect(() => {
    api.get("/catalog/themes").then((r) => setThemes(r.data)).catch(() => setThemes([]));
  }, []);
  useEffect(() => {
    const params = isAll ? {} : { category: categorySlug };
    if (theme) params.theme = theme;
    api.get("/catalog/products", { params })
      .then((r) => setApiProducts(r.data.map(mapApiProduct)))
      .catch(() => setApiProducts([]));
  }, [categorySlug, isAll, theme]);
  const products = apiProducts;

  return (
    <div className="container-ae py-12 md:py-16" data-testid="category-page">
      <nav className="mb-6 text-sm text-muted-foreground" aria-label="Fil d'Ariane">
        <Link to="/boutique" className="hover:text-deepgreen" data-testid="breadcrumb-boutique">Boutique</Link>
        <span className="mx-2">/</span>
        <span className="text-deepgreen">{isAll ? "Tous les articles" : category?.name || categorySlug}</span>
      </nav>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-3xl sm:text-4xl text-deepgreen" data-testid="category-title">
            {isAll ? "Tous les articles" : category?.name || "Catégorie"}
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">{products?.length ?? 0} article{(products?.length ?? 0) > 1 ? "s" : ""} — consultation libre, sans date obligatoire</p>
        </div>
      </div>
      {themes.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-2" data-testid="theme-filters">
          <button type="button" onClick={() => setTheme("")} data-testid="theme-filter-all"
            className={`rounded-full border px-4 py-2 text-xs font-semibold transition-colors ${!theme ? "border-deepgreen bg-deepgreen text-cream" : "border-border bg-white text-deepgreen hover:border-deepgreen"}`}>
            Tous les univers
          </button>
          {themes.map((t) => (
            <button key={t} type="button" onClick={() => setTheme(theme === t ? "" : t)} data-testid={`theme-filter-${t.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-")}`}
              className={`rounded-full border px-4 py-2 text-xs font-semibold transition-colors ${theme === t ? "border-deepgreen bg-deepgreen text-cream" : "border-border bg-white text-deepgreen hover:border-deepgreen"}`}>
              {t}
            </button>
          ))}
        </div>
      )}
      {products === null ? (
        <div className="mt-10 py-10 text-center font-heading text-deepgreen" data-testid="category-loading">Chargement…</div>
      ) : products.length === 0 ? (
        <div className="mt-10">
          <EmptyState title="Aucun article dans cette catégorie pour le moment">
            Le catalogue réel sera complété par Art Event depuis l'administration.
          </EmptyState>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 gap-6 lg:grid-cols-3 xl:grid-cols-4" data-testid="category-products-grid">
          {products.map((p) => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
